.carousel {
  position: relative;
  display: grid;
  gap: 17px;
}

.arrow {
  display: none;
}

.arrowLeft {
  left: -75px;
  z-index: 10;
  padding: 64px 15px 64px 26px;
}

.arrowRight {
  right: -80px;
  padding: 64px 26px 64px 15px;
}

.sliderContainer {
  max-width: 100%;
  overflow-x: hidden;
}

.sliderWrapper {
  position: relative;

  /* 左と右の両方はBLURの部分を表示されるように２倍のblurOffset(=64px)を足す */

  width: 100%;
  overflow-x: hidden;
}

.slider {
  display: flex;
  gap: 16px;
  overflow-x: scroll;
  scroll-behavior: smooth;
  transition: all 0.6s cubic-bezier(0.51, 0.94, 0.58, 1);

  &::-webkit-scrollbar {
    display: none;
  }
}

@container press-release-root (min-width: 1280px) {
  .arrowCQ {
    position: absolute;
    top: 22px;
    display: block;

    &:hover {
      background-color: rgb(0 0 0 / 5%);
      border-radius: 8px;
    }
  }

  .sliderContainerCQ {
    max-width: 1126px;
    overflow-x: visible;
  }

  .sliderWrapperCQ {
    left: -64px;
    width: calc(100% + 128px);
  }

  .sliderCQ {
    position: relative;
    gap: 26px;
    width: 100%;

    /* sliderWidth: 1126 - blurOffset: 64 */
    padding-right: 1062px;
    padding-left: 64px;
    overflow-x: visible;
  }
}

@media screen and (width >= 1280px) {
  .arrowFallback {
    position: absolute;
    top: 22px;
    display: block;

    &:hover {
      background-color: rgb(0 0 0 / 5%);
      border-radius: 8px;
    }
  }

  .sliderContainerFallback {
    max-width: 1126px;
    overflow-x: visible;
  }

  .sliderWrapperFallback {
    left: -64px;
    width: calc(100% + 128px);
  }

  .sliderFallback {
    position: relative;
    gap: 26px;
    width: 100%;

    /* sliderWidth: 1126 - blurOffset: 64 */
    padding-right: 1062px;
    padding-left: 64px;
    overflow-x: visible;
  }
}
